import { SettingsInfo } from '@/services/settingsService';
import { useMemo } from 'react';
import {
  AiPipelineChoices,
  AiToolsChoices,
} from '@/services/settingsService/aiTypes';
import { useEditorSettings } from '@/services/editorService';
import { fromCamelCaseToSnakeCase } from '@/core/objectManipulation/objectManipulation';

export const useLastAiToolsChoices = (
  settings: SettingsInfo,
  aiPipeline?: AiPipelineChoices
) => {
  const { buildDefaultAiToolsChoices } = useEditorSettings();

  return useMemo(() => {
    if (!aiPipeline || !settings.areReady) {
      return buildDefaultAiToolsChoices();
    }

    const choices: AiToolsChoices = {};

    Object.entries(aiPipeline).forEach(([pipelineStep, stepValue]) => {
      if (typeof stepValue !== 'object') {
        return;
      }

      const pipelineStepTransformed = fromCamelCaseToSnakeCase(pipelineStep);
      choices[pipelineStepTransformed] = stepValue;
    });

    return choices;
  }, [aiPipeline, buildDefaultAiToolsChoices, settings.areReady]);
};
